export default __webpack_public_path__ + "beta-maps-guides-outdoors-960-a8e4cdaf16eada9778bf1ca77814b448.png";